<template>
  <div class="custom-slider-home">
    
    <div class="main-custom-slider" ref="sliderRef" @scroll="handleScroll">
      <div class="custom-slider">
        <a
          v-for="item in props.data"
          :key="item.item_title"
          :href="getLangUrl(item.item_title_link, baseUrl, locale)"
          class="custom-slide"
        >
          <span class="custom-slide-title">{{ item.item_title }}</span>
        </a>
      </div>
    </div>
    <div class="progress-bar-wrapper">
      <div class="progress-bar-inner" :style="{ width: progress + '%' }"></div>
    </div>
  </div>
</template>


<script setup lang="ts">
    import { ref, onMounted, nextTick } from 'vue'

    const props = defineProps(["data"]);
    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    const wooStore = useWooStore();
    const countryShort = wooStore.country?.country_short;
    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();
    import { getLangUrl } from '~/utils/getLangUrl';

    const sliderRef = ref<HTMLElement | null>(null)
    const progress = ref(10) 
    const handleScroll = () => {
      const el = sliderRef.value
      if (!el) return
      const scrollLeft = el.scrollLeft
      const maxScroll = el.scrollWidth - el.clientWidth
      const rawProgress = (scrollLeft / maxScroll) * 100
      progress.value = Math.min(100, Math.max(10, rawProgress))
    }

    onMounted(() => {
      nextTick(() => {
        handleScroll()
      })
    })

</script>

<style scoped lang="scss">
    .progress-bar-wrapper {
      height: 3px;
      background: #fee5da;
      width: 100%;
      margin-top: 5px;
      border-radius: 2px;
      overflow: hidden;
    }
    .progress-bar-inner {
      height: 100%;
      background-color: #c60c46;
      transition: width 0.2s ease;
      width: 0%;
    }
    .main-custom-slider::-webkit-scrollbar {
        display: none;
      }

      .main-custom-slider {
          margin-right: 15px;
          overflow-x: auto;
          white-space: nowrap;
          padding: 5px 0;
          margin-left: 15px;
          -ms-overflow-style: none;
          scrollbar-width: none;
      }

      .custom-slider-home {
        display: none;
        position: relative;
      }
      .custom-slider-home .img_slider_arr_right {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 27px;
      }
      .custom-slider {
        display: flex;
        gap: 25px;
      }
      .custom-slide {
        line-height: 1;
        text-decoration: none !important;
      }
      .custom-slide .custom-slide-title{
        color: #000000;
        font-weight: 400;
        font-size: 13px;
        letter-spacing: 0.4px;
      }
      @media (max-width: 1019px) {
        .custom-slider-home {
          display: block; 
          background: #ffffff;
        }
      }
</style>